import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const AIGeneral = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M16.648 12.258a.369.369 0 01.704 0l.763 2.442c.177.565.62 1.008 1.185 1.185l2.442.763a.369.369 0 010 .704l-2.442.763a1.806 1.806 0 00-1.185 1.185l-.763 2.442a.369.369 0 01-.704 0l-.763-2.442a1.806 1.806 0 00-1.185-1.185l-2.442-.763a.369.369 0 010-.704l2.442-.763a1.806 1.806 0 001.185-1.185l.763-2.442zm-8.14-9.897a.516.516 0 01.984 0l1.07 3.42c.247.79.867 1.41 1.658 1.657l3.419 1.07a.516.516 0 010 .984l-3.42 1.07a2.528 2.528 0 00-1.657 1.658l-1.07 3.419a.516.516 0 01-.984 0l-1.07-3.42a2.528 2.528 0 00-1.658-1.657l-3.419-1.07a.516.516 0 010-.984l3.42-1.07A2.528 2.528 0 007.437 5.78l1.07-3.419z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M16.648 12.258a.369.369 0 01.704 0l.763 2.442c.177.565.62 1.008 1.185 1.185l2.442.763a.369.369 0 010 .704l-2.442.763a1.806 1.806 0 00-1.185 1.185l-.763 2.442a.369.369 0 01-.704 0l-.763-2.442a1.806 1.806 0 00-1.185-1.185l-2.442-.763a.369.369 0 010-.704l2.442-.763a1.806 1.806 0 001.185-1.185l.763-2.442zm-8.14-9.897a.516.516 0 01.984 0l1.07 3.42c.247.79.867 1.41 1.658 1.657l3.419 1.07a.516.516 0 010 .984l-3.42 1.07a2.528 2.528 0 00-1.657 1.658l-1.07 3.419a.516.516 0 01-.984 0l-1.07-3.42a2.528 2.528 0 00-1.658-1.657l-3.419-1.07a.516.516 0 010-.984l3.42-1.07A2.528 2.528 0 007.437 5.78l1.07-3.419z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
AIGeneral.displayName = "AIGeneralIcon";

export { AIGeneral, AIGeneral as default };
